import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Async
import AccountsAsync from './accountsAsync';
// Types
import { PaymentProviders } from "types/PaymentTypes";

interface IState {
  settings: {
    paymentProvider: PaymentProviders | null;
    paymentCreditCardEnabled: boolean;
    paymentAchEnabled: boolean;
    chatModuleEnabled: boolean | null;
    squareLocationId: string;
    squareApplicationId: string;
    pollModuleEnabled: boolean | null;
  };
  byDomain: {
    settings: any;
  };
}

const initialState:IState = {
  settings: {
    paymentProvider: null,
    paymentCreditCardEnabled: false,
    paymentAchEnabled: false,
    chatModuleEnabled: null,
    squareLocationId: '',
    squareApplicationId: '',
    pollModuleEnabled: null,
  },
  byDomain: {
    settings: null,
  },
};

const accountsSlice = createSlice({
  name: 'accounts',
  initialState,
  reducers: { },
  extraReducers: (builder) => {
    builder
      // Fetch accounts settings
      .addCase(AccountsAsync.fetchAccountsSetting.fulfilled, (state, action: PayloadAction<any>) => {
        state.settings = action.payload;
      })
      // Get by domain
      .addCase(AccountsAsync.getByDomain.fulfilled, (state, action: PayloadAction<any>) => {
        state.byDomain = action.payload;
      })
  }
});

export const AccountsActions = accountsSlice.actions;

export default accountsSlice.reducer;
